export default "__VITE_ASSET__kk_uNAeW__"